import { generateUtilityColorsContrastRange } from "@seneca/senekit";
import { ContrastRange } from "@seneca/senekit/out/styles/colors/types";

import {
  Department,
  getSubjectDepartment,
  isDepartment,
  isSubject,
  SubjectGB
} from "features/common/subjects/consts";

export const DEFAULT_GREY = "#e3e2e2";

type ColorSet = {
  color: ContrastRange;
  contrast: keyof ContrastRange;
};

const utilityColorsContrastRange = generateUtilityColorsContrastRange();

// don't change the order of departments, it's important to show the relevant order in departments filter dropdown
export const departmentColorMap: {
  [department in Department]: ColorSet;
} = Object.freeze({
  [Department.science]: {
    color: utilityColorsContrastRange.green,
    contrast: "60"
  },
  [Department.english]: {
    color: utilityColorsContrastRange.magenta,
    contrast: "60"
  },
  [Department.geography]: {
    color: utilityColorsContrastRange.cyan,
    contrast: "60"
  },
  [Department.history]: {
    color: utilityColorsContrastRange.orange,
    contrast: "40"
  },
  [Department.mfl]: {
    color: utilityColorsContrastRange.yellow,
    contrast: "70"
  },
  [Department.computerScience]: {
    color: utilityColorsContrastRange.neutralMono,
    contrast: "60"
  },
  [Department.religiousStudies]: {
    color: utilityColorsContrastRange.magenta,
    contrast: "80"
  },
  [Department.business]: {
    color: utilityColorsContrastRange.chartreuse,
    contrast: "50"
  },
  [Department.maths]: {
    color: utilityColorsContrastRange.blue,
    contrast: "50"
  },
  [Department.socialScience]: {
    color: utilityColorsContrastRange.magenta,
    contrast: "80"
  },
  [Department.designTechnology]: {
    color: utilityColorsContrastRange.neutralMono,
    contrast: "60"
  },
  [Department.foodPrep]: {
    color: utilityColorsContrastRange.yellow,
    contrast: "80"
  },
  [Department.pe]: {
    color: utilityColorsContrastRange.pink,
    contrast: "30"
  },
  [Department.economics]: {
    color: utilityColorsContrastRange.chartreuse,
    contrast: "50"
  },
  [Department.politics]: {
    color: utilityColorsContrastRange.chartreuse,
    contrast: "50"
  },
  [Department.mediaStudies]: {
    color: utilityColorsContrastRange.neutralMono,
    contrast: "60"
  },
  [Department.music]: {
    color: utilityColorsContrastRange.violet,
    contrast: "60"
  },
  [Department.drama]: {
    color: utilityColorsContrastRange.violet,
    contrast: "60"
  },
  [Department.vocational]: {
    color: utilityColorsContrastRange.yellow,
    contrast: "80"
  },
  [Department.personalDevelopment]: {
    color: utilityColorsContrastRange.green,
    contrast: "90"
  }
});

export function getSubjectColor(subject?: string | SubjectGB): string {
  if (!subject || !isSubject(subject)) return DEFAULT_GREY;
  const subjectDepartment = getSubjectDepartment(subject);
  if (!subjectDepartment) return DEFAULT_GREY;
  return getDepartmentColor(subjectDepartment);
}

export function getDepartmentColor(department: string | Department) {
  if (!isDepartment(department)) return DEFAULT_GREY;
  const { color, contrast } = departmentColorMap[department];
  return color[contrast];
}
